export default "__VITE_ASSET__5e900ce0__"